import React from "react";
import ActionGroup from "../components/ActionGroup";
import SiteLayout from "../components/SiteLayout";
import TestimonialCard from "../components/TestimonialCard";
import { resultsShowcase, testimonials, utilityActions } from "../siteContent";

const ClientResults = () => {
  return (
    <SiteLayout>
      <section className="page-hero page-hero--client-results">
        <div className="container page-hero__grid client-results-hero">
          <div className="client-results-hero__copy">
            <h1>Happy Clients</h1>
            <p className="lead">
              Specialist work designed to soften regrowth, honour natural grey,
              and create polished, lower-maintenance colour with a luxury feel.
            </p>
            <ActionGroup
              actions={utilityActions}
              className="client-results-hero__actions"
            />
          </div>

          <figure className="client-results-hero__image">
            <img
              alt="Grey blending transformation by Lizzie Fox Colour Studio"
              src="/clientMedia/gb1.png"
            />
          </figure>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-heading">
            <p className="section-eyebrow">Transformation Stories</p>
            <h2>Before, after, and the feeling in between</h2>
          </div>

          <div className="results-grid">
            {resultsShowcase.map((result) => (
              <article className="result-card" key={result.title}>
                <div className="result-card__media">
                  <img alt={result.title} src={result.image} />
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tinted">
        <div className="container">
          <div className="section-heading">
            <p className="section-eyebrow">Testimonials</p>
            <h2>What clients say after the transformation</h2>
          </div>

          <div className="testimonial-grid">
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.author} testimonial={testimonial} />
            ))}
          </div>
        </div>
      </section>
    </SiteLayout>
  );
};

export default ClientResults;
